import { compact } from "lodash";

export function transformFiltersFromJob(job: any) {
  if (!job) {
    return {
      function: [],
      segment: [],
      skill: [],
    };
  }

  return {
    function: compact<{ id: string; name: string }>(
      job.personas?.map((tag: any) => {
        const { persona } = tag ?? {};
        return {
          id: persona?.id,
          name: persona?.name,
        };
      }),
    ),
    segment: compact<{ id: string; name: string }>(
      job.functionalAreas?.map((tag: any) => {
        return {
          id: tag?.id,
          name: tag?.name,
        };
      }),
    ),
    skill: compact<{ id: string; name: string }>(
      job.requiredSkills?.map((tag: any) => {
        return {
          id: tag?.id,
          name: tag?.name,
        };
      }),
    ),
  };
}
